import {
  TextButtonPriority,
  TextButton,
  TextButtonProps,
} from '../../TextButton';

export class AvatarGroupTextButton extends TextButton {
  static defaultProps: TextButtonProps = {
    priority: TextButtonPriority.secondary,
  };
}
